export default "__VITE_ASSET__D4fl6849__"